/**
 * Returns the dynamic API base URL.
 * Always uses window.location.origin so the app works on any domain
 * (custom domains, preview URLs, etc.) without CORS issues.
 * REACT_APP_BACKEND_URL is NOT used because React bakes .env values
 * into the bundle at build time, causing cross-origin failures
 * when deployed under a different domain than the build environment.
 */
export const getApiBaseUrl = () => window.location.origin;
